import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { TopNavbarStyled } from '../TopNavbarStyled';
import { rem } from 'polished';

export const TopNavbarStyledAC = styled(TopNavbarStyled)`
    background: ${p => p.theme.colors.champagne1};
    border-bottom: none;

    .topnavbar-grid {
        padding: 0;
        width: 100vw;
        @media (min-width: ${breakpoints.xs}px) {
            width: 100%;
            padding: 0 10px;
        }
    }

    .content {
        display: flex;
        justify-content: center;
        position: relative;

        &-title {
            text-transform: uppercase;
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            color: ${p => p.theme.colors.grey5};
        }

        &-step {
            font-weight: ${p => p.theme.fontWeights.textBold};
        }
    }

    .topnavbar-returnlink {
        cursor: pointer;
        color: ${p => p.theme.colors.blue2};
        text-transform: capitalize;
        border-radius: ${rem(24)};
        font-size: ${p => p.theme.fontSizes.h4};
        border: 2px solid ${p => p.theme.colors.blue2};
        font-weight: ${p => p.theme.fontWeights.textBold};
        display: flex;
        align-items: baseline;
        min-width: ${rem('80px')};
        padding: 0.6rem 1rem;
        
        @media (max-width: ${breakpoints.md}px) {
            border: 2px solid ${p => p.theme.colors.red};
            width: ${rem(20)};
            justify-content: center;
            padding: ${rem(5)};
            
            .icon-wrapper {
                width: ${rem(30)} !important;
                
                svg {
                    path {
                        stroke: ${p => p.theme.colors.red};
                        fill: none;
                    }
                }
            }
        }

        &__text {
            display: none;

            @media (min-width: ${breakpoints.xs}px) {
                display: inline-block;
            }
        }

        &:not(.isDisabled) {
            :hover,
            :focus-visible {
                background-color: ${(p) => p.theme.colors.champagne1};
                border-color: ${(p) => p.theme.colors.grey5};
                color: ${(p) => p.theme.colors.grey5};
                svg {
                    path {
                        stroke: ${(p) => p.theme.colors.grey5};
                    }
                }
            }
        }

        .icon-wrapper {
            width: ${rem('13px')};
            height: auto;

            @media (min-width: ${breakpoints.xs}px) {
                width: ${rem('13px')};
                margin-right: ${rem('4px')};
            }
        }

        svg {
            height: ${rem('36px')};
            width: ${rem('30px')};

            @media (min-width: ${breakpoints.xs}px) {
                height: ${rem('8px')};
                width: ${rem('13px')};
                margin: 0 0 ${rem('2px')} 0;
                path {
                    stroke: ${p => p.theme.colors.blue2};
                    fill: transparent;
                }
            }
        }
    }

    .save-button {
        border-color: ${p => p.theme.colors.primary};
        color: ${p => p.theme.colors.primary};
        font-family: ${p => p.theme.fonts.fontSecondary};
        font-size: ${rem('12px')};
        padding-right: ${rem('40px')};
        padding-left: ${rem('40px')};
    }

    .Select {
        &__control {
            border: none;
        }

        &__indicators {
            padding: 4px;

            @media (min-width: ${breakpoints.sm}px) {
                padding: 5px;
            }

            @media (min-width: ${breakpoints.md}px) {
                padding: 8px;
            }
        }
    }
`;
